import React from 'react';
import { Badge, colors } from '@mui/material';

const DashboardMobileTabBadgeCounter = ({ sx = {}, ...props }) => (
  <Badge
    {...props}
    sx={[
      {
        '& .MuiBadge-badge': {
          backgroundColor: colors.amber[600],
          color: colors.grey[900],
        },
      },
      sx,
    ]}
  />
);

export default DashboardMobileTabBadgeCounter;
